import Header from "../../components/header/Header";
import Banner from "./banner/Banner";
import WhyDigitalClone from "./why-clone/WhyDigitalClone";
import CaseStudies from "./case-studies/CaseStudies";
import Integration from "./integration/Integration";
import Pricing from "./pricing/Pricing";
import Contact from "./contact/Contact";
import Footer from "../../components/footer/Footer";
import BlogList from "./blog-list/BlogList";

export default function HomePage() {
  return (
    <>
      <Header />
      <Banner />
      <WhyDigitalClone />
      {/* <GeneralInfo /> */}
      <CaseStudies />
      <Integration />
      <Pricing />
      <BlogList />
      <Contact />
      <Footer />
    </>
  );
}
